import { call, put, takeEvery } from "redux-saga/effects";
import {
  getPaymentFormulas,
  hidePaymentFormulasLoader,
  setErrorPaymentFormulas,
  setPaymentFormulas,
  setPaymentFormulasForId,
  setPaymentFormulasParams,
  showPaymentFormulasLoader
} from "./actions";
import {
  ADD_PAYMENT_FORMULAS,
  DELETE_PAYMENT_FORMULAS,
  GET_PAYMENT_FORMULAS,
  GET_PAYMENT_FORMULAS_FOR_ID,
  GET_PAYMENT_FORMULAS_PARAMS,
  PATCH_PAYMENT_FORMULAS
} from "./actionType";
import { getErrorMessage, showErrorMessage, showSuccessMessage } from "../../helpers/utils";
import {
  deletePaymentFormula,
  getPaymentFormula,
  getPaymentFormulaProfile,
  getPaymentParams,
  patchPaymentFormulaProfile,
  postPaymentFormula
} from "../../helpers/jwt_helper";

function* onGetPaymentFormulas({ payload: data }) {
  try {
    yield put(showPaymentFormulasLoader());
    let response = yield call(getPaymentFormula, {
      page: data.page,
      size: data.sizePerPage,
      ordering: data.ordering,
      search: data.search,
    });
    response = {
      ...data,
      ...response,
    }
    yield put(setPaymentFormulas(response));
    yield put(hidePaymentFormulasLoader());
  } catch (e) {
    showErrorMessage(getErrorMessage(e));
    yield put(hidePaymentFormulasLoader());
  }
}

function* onPostPaymentFormulas({ payload: { formula, data } }) {
  try {
    yield put(showPaymentFormulasLoader());
    yield call(postPaymentFormula, {
      formula: formula,
      created_at: new Date().toISOString(),
    });
    yield call(onGetPaymentFormulas, { payload: data });
    yield put(hidePaymentFormulasLoader());
    showSuccessMessage(
      "Payment formula has been added"
    );
  } catch (e) {
    showErrorMessage(getErrorMessage(e));
    yield put(hidePaymentFormulasLoader());
  }
}

function* onGetPaymentFormulasForId({ payload: id }) {
  try {
    yield put(setErrorPaymentFormulas(false));
    let res = yield call(getPaymentFormulaProfile, id);
    yield put(setPaymentFormulasForId(res));
  } catch (error) {
    if (getErrorMessage(error) === 'Not found.') {
      yield put(setErrorPaymentFormulas(true));
    }
    showErrorMessage(getErrorMessage(error));
  }
}

function* onPatchPaymentFormulas({ payload: { id, formula, data } }) {
  try {
    yield put(showPaymentFormulasLoader());
    yield call(patchPaymentFormulaProfile, id, {
      formula: formula,
      created_at: new Date().toISOString(),
    });
    yield call(getPaymentFormulas, { payload: data })
    yield put(hidePaymentFormulasLoader());
    showSuccessMessage('Payment formula has been updated');
  } catch (e) {
    showErrorMessage(getErrorMessage(e));
    yield put(hidePaymentFormulasLoader());
  }
}

function* onDeletePaymentFormulas({ payload: { id, data } }) {
  try {
    yield put(showPaymentFormulasLoader());
    yield call(deletePaymentFormula, id);
    yield call(onGetPaymentFormulas, { payload: data });
    yield put(hidePaymentFormulasLoader());
    showSuccessMessage("Payment formula has been deleted");
  } catch (e) {
    yield put(hidePaymentFormulasLoader());
    showErrorMessage(getErrorMessage(e));
  }
}

function* onGetPaymentFormulasParams({ payload: data }) {
  try {
    let res = yield call(getPaymentParams, data);
    yield put(setPaymentFormulasParams(res));
  } catch (e) {
    showErrorMessage(getErrorMessage(e));
  }
}

function* PaymentFormulasSaga() {
  yield takeEvery(GET_PAYMENT_FORMULAS, onGetPaymentFormulas);
  yield takeEvery(GET_PAYMENT_FORMULAS_FOR_ID, onGetPaymentFormulasForId);
  yield takeEvery(DELETE_PAYMENT_FORMULAS, onDeletePaymentFormulas);
  yield takeEvery(PATCH_PAYMENT_FORMULAS, onPatchPaymentFormulas);
  yield takeEvery(ADD_PAYMENT_FORMULAS, onPostPaymentFormulas);
  yield takeEvery(GET_PAYMENT_FORMULAS_PARAMS, onGetPaymentFormulasParams);
}

export default PaymentFormulasSaga;
